export default __webpack_public_path__ + "static/media/lateral_b.438ec4f8.jpg";